import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const productListPromise = import("./ProductList.js");
export default Auth(lazy(() => productListPromise));